import { useSelector } from "react-redux";
import { matchRoutes, useLocation } from "react-router";
import { appRoute } from "../../routes/appRouteConfig";

const useCurrenPath = () => {
  const location = useLocation();
  const { currentBizzApp } = useSelector((state) => state.bizzApps);
  const totalRoute = currentBizzApp
    ? appRoute.find(
        (item) => item.bizzApp === currentBizzApp?.alias?.toUpperCase()
      )?.listRoute
    : [];

  const listRoutes = appRoute.reduce((current, next) => {
    const currentRoute = current ?? [];
    return currentRoute.concat(next.listRoute);
  }, []);

  const [{ route: currentRoute }] = matchRoutes(listRoutes, location) ?? [
    { route: null },
  ];

  const isAvailableRoute =
    location.pathname === "/" ||
    location.pathname === "/user" ||
    totalRoute?.some(
      (item) =>
        currentRoute?.path === item.path || item.path === location.pathname
    );

  return { isAvailableRoute, currentRoute };
};

export default useCurrenPath;
